import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminDashboard from './components/AdminDashboard';
import EmployeeDashboard from './components/EmployeeDashboard';
import AddMedicine from './components/AddMedicine/AddMedicine.js';
import AddMedicineFromExcel from './components/Addexcel/AddMedicineFromExcel.js';
import AddMedicalStore from './components/AddMedicalStore/AddMedicalStore.jsx';
import EmployeeList from './components/UserVarification/EmployeeList.jsx';
import Login from './components/Login/Login.js';
import AddHospital from './components/HospitalManage/AddHospital.jsx';
import HospitalManagement from './components/HospitalManage/HospitalManage.jsx';
import AddDoctor from './components/HospitalManage/AddDoctor.jsx';
import DoctoronCalender from './components/DoctorAppointment/doctoronCalender.jsx';


function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Login />} />
          
          {/* Protected Admin Routes */}
          <Route 
            path="/admin-dashboard" 
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
          
          {/* Protected Employee Routes */}
          <Route 
            path="/employee-dashboard" 
            element={
              <ProtectedRoute>
                <EmployeeDashboard />
              </ProtectedRoute>
            } 
          />
          
          {/* Protected Admin Only Routes */}
          <Route 
            path="/add-doctor" 
            element={
              <ProtectedRoute requiredRole="admin">
                <AddDoctor />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/calender" 
            element={
              <ProtectedRoute requiredRole="admin">
                <DoctoronCalender/>
              </ProtectedRoute>
            } 
          />


          <Route 
            path="/add-hospital" 
            element={
              <ProtectedRoute requiredRole="admin">
                <AddHospital />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/manage-hospital" 
            element={
              <ProtectedRoute requiredRole="admin">
                <HospitalManagement />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/add-medicine" 
            element={
              <ProtectedRoute requiredRole="admin">
                <AddMedicine />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/add-medicine-excel" 
            element={
              <ProtectedRoute requiredRole="admin">
                <AddMedicineFromExcel />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/add-medicalstore" 
            element={
              <ProtectedRoute requiredRole="admin">
                <AddMedicalStore />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/get-employees" 
            element={
              <ProtectedRoute requiredRole="admin">
                <EmployeeList />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
